var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-content"
  }, [_c('PageHeader', [_c('PageHeaderTitleContent', [_c('TitleTextContent', {
    attrs: {
      "titleText": _vm.newsHeaderTitle,
      "subTitleText": 'What’s in the news? Project Spectrum keeps an eye on the latest cybersecurity tech trends, emerging technologies, compliance standards, cyber threats, and much more! Check out the latest news from around the web.'
    }
  }), _vm.isRecentNews ? _c('router-link', {
    attrs: {
      "to": {
        name: 'cybercorner'
      }
    }
  }, [_c('v-btn', {
    staticClass: "mt-4",
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": '#424EC4'
    }
  }, [_vm._v(" Back to Cyber Corner ")])], 1) : _vm._e()], 1)], 1), _c('section', {
    staticClass: "section p-0 mt-5 section-content"
  }, [_c('div', {
    staticClass: "container-fluid px-xs-1 px-md-5 px-lg-5 px-xl-5"
  }, [_vm._m(0), _vm.totalRows > 0 ? _c('div', {
    staticClass: "mb-5"
  }, [_c('SearchControlWidget', {
    attrs: {
      "inputTextPlaceholder": 'Enter news title here',
      "searchControlHeight": '100px',
      "searchQueryInputHandler": _vm.updateSearchQuery
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "blog-post-grid"
  }, [_c('div', {
    staticClass: "row mb-4"
  }, _vm._l(_vm.displayedNewsItems, function (item) {
    return _c('NewsCard', {
      key: item.id,
      attrs: {
        "newsItem": item,
        "newsPage": _vm.currentPage,
        "query": _vm.searchQuery,
        "isRecentNews": _vm.isRecentNews
      }
    });
  }), 1)]), _vm.totalRows > 0 && _vm.totalRows > _vm.perPage ? _c('div', {
    staticClass: "mb-5"
  }, [_c('b-pagination', {
    staticClass: "m-0",
    attrs: {
      "id": "news-pagination",
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "align": "center"
    },
    on: {
      "page-click": _vm.pageClicked
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1) : _vm._e(), _vm.displayedNewsItems.length === 0 ? _c('div', {
    staticClass: "row m-0 w-100 mb-4",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "col-12 p-0 d-flex justify-content-center align-items-center empty-blog-message text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.newsItems.length === 0 ? `There are no blogs available within the last six months` : `There are no blog items available for the blog search: 
						<br>
						&quot${_vm.searchQuery}&quot
						`)
    }
  })]) : _vm._e(), _vm.isRecentNews ? _c('div', {
    staticClass: "d-flex flex-row justify-content-center mb-5"
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": '#424EC4',
      "width": "240"
    },
    on: {
      "click": _vm.goToNewsArchives
    }
  }, [_vm._v(" View News Archives ")])], 1) : _c('div', {
    staticClass: "d-flex flex-row justify-content-center mb-5"
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": '#424EC4',
      "width": "240"
    },
    on: {
      "click": _vm.goToRecentNews
    }
  }, [_vm._v(" Back To Recent ")])], 1)])])], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-100 d-flex justify-content-center section-title"
  }, [_c('span', [_vm._v("STAY UP TO DATE")])]);

}]

export { render, staticRenderFns }